import { styled } from '@mui/styles';

export const Code = styled('code')(({ theme }) => ({
	backgroundColor: theme.palette.background.secondary,
	fontFamily: 'monospace',
	padding: '0.2em 0.4em',
	fontSize: '90%',
	borderRadius: 6,
}));
